import Amplitude from 'amplitude-js';
import ENDPOINTS from './Endpoints';

const isProduction = () => process.env.NODE_ENV !== 'development';

export const FIRST_VISIT = 'FIRST_VISIT';
export const CTA_CLICK = 'CTA_CLICK';


const consoleTrack =
    // eslint-disable-next-line
    process.env.NODE_ENV === 'development'
        ? (system, ...args) => console.log(`Analytic event track to ${system}: `, ...args)
        : () => {};
const AmplitudeWrapper = (...args) => {
    consoleTrack('Amplitude', ...args);
    Amplitude.logEvent(...args);
};

export const trackEventToAnalytics = (eventName, payload = {}) => {
    let preland;
    switch (window.location.pathname) {
        case `/${ENDPOINTS.PRE_LAND_IOS1}`: {
            preland = 'ios1';
            break;
        }
        case `/${ENDPOINTS.PRE_LAND_IOS2}`: {
            preland = 'ios2';
            break;
        }
        case `/${ENDPOINTS.PRE_LAND_IOS3}`: {
            preland = 'ios3';
            break;
        }
        case `/${ENDPOINTS.PRE_LAND_IOS4}`: {
            preland = 'ios4';
            break;
        }
        case `/${ENDPOINTS.PRE_LAND_IOS5}`: {
            preland = 'ios5';
            break;
        }
        case `/${ENDPOINTS.PRE_LAND_IOS6}`: {
            preland = 'ios6';
            break;
        }
        default: {}
    }
    switch (eventName) {
        case FIRST_VISIT: {
            if (getCookie('alreadyPreLandVisit')) {
                break;
            }

            AmplitudeWrapper('firstVisit', { preland });
            setCookie('alreadyPreLandVisit', '1');
            break;
        }

        case CTA_CLICK: {
            AmplitudeWrapper('ctaClick', {
                link: payload.link,
                preland
            });
        }

        default:
            break;
    }
};

export async function initAnalytics() {
    const amplitudeKey = isProduction() ? 'f67436a33fd59f0b636775257c8db431' : 'ff3ec71496802ef63f64109ec5e68088';

    Amplitude.init(amplitudeKey, null, {
        includeReferrer: true,
        includeUtm: true,
        includeGclid: true,
        saveParamsReferrerOncePerSession: false,
    });

    Amplitude.setUserProperties({
        appName: 'web2app',
        appDomain: window.location.hostname,
        // eslint-disable-next-line
        deviceOS: `${Amplitude._instances.$default_instance._ua.os.name} ${
            // eslint-disable-next-line
            Amplitude._instances.$default_instance._ua.os.version
        }`,
    });

    trackEventToAnalytics(FIRST_VISIT);
}

export function getCookie(name) {
    const matches = document.cookie.match(
        // eslint-disable-next-line
        new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options) {
    options = options || { expires: 31556926 };

    let expires = options.expires;

    if (typeof expires === 'number' && expires) {
        const d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        options.expires = d;
        expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    document.cookie = Object.keys(options).reduce((acc, propName) => {
        acc += `; ${propName}`;
        const propValue = options[propName];
        if (propValue !== true) {
            acc += `=${propValue}`;
        }
        return acc;
    }, `${name}=${value}`);
}
